(() => {
  const SELECTOR = '[data-mme-typewriter]';
  const TYPE_DELAY = 95;
  const DELETE_DELAY = 55;
  const HOLD_DELAY = 1900;
  const BETWEEN_DELAY = 350;

  function stopTypewriter(element) {
    if (element._mmeTypewriterTimer) {
      window.clearTimeout(element._mmeTypewriterTimer);
      element._mmeTypewriterTimer = null;
    }
  }

  function initTypewriter(element) {
    stopTypewriter(element);

    const output = element.querySelector('.mme-typewriter__text');
    const phrases = [1, 2, 3, 4]
      .map((index) => element.getAttribute(`data-phrase-${index}`))
      .filter((phrase) => phrase && phrase.trim());
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!output || !phrases.length) return;

    output.textContent = phrases[0];
    element.dataset.typewriterReady = 'true';

    if (reducedMotion || phrases.length < 2) {
      element.dataset.typewriterState = 'static';
      return;
    }

    let phraseIndex = 0;
    let characterIndex = phrases[0].length;
    let deleting = true;

    function schedule(delay) {
      element._mmeTypewriterTimer = window.setTimeout(tick, delay);
    }

    function tick() {
      const phrase = phrases[phraseIndex];

      if (deleting) {
        characterIndex = Math.max(0, characterIndex - 1);
        output.textContent = phrase.slice(0, characterIndex);
        element.dataset.typewriterState = 'deleting';

        if (characterIndex === 0) {
          phraseIndex = (phraseIndex + 1) % phrases.length;
          deleting = false;
          element.dataset.phraseIndex = String(phraseIndex);
          schedule(BETWEEN_DELAY);
          return;
        }

        schedule(DELETE_DELAY);
        return;
      }

      const nextPhrase = phrases[phraseIndex];
      characterIndex = Math.min(nextPhrase.length, characterIndex + 1);
      output.textContent = nextPhrase.slice(0, characterIndex);
      element.dataset.typewriterState = 'typing';

      if (characterIndex === nextPhrase.length) {
        deleting = true;
        element.dataset.typewriterState = 'holding';
        schedule(HOLD_DELAY);
        return;
      }

      schedule(TYPE_DELAY);
    }

    element.dataset.phraseIndex = '0';
    element.dataset.typewriterState = 'holding';
    schedule(HOLD_DELAY);
  }

  function initTypewriters(root = document) {
    const elements = [];

    if (root.matches?.(SELECTOR)) elements.push(root);
    root.querySelectorAll?.(SELECTOR).forEach((element) => elements.push(element));
    elements.forEach(initTypewriter);
  }

  function stopTypewriters(root) {
    if (root.matches?.(SELECTOR)) stopTypewriter(root);
    root.querySelectorAll?.(SELECTOR).forEach(stopTypewriter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTypewriters(), { once: true });
  } else {
    initTypewriters();
  }

  document.addEventListener('shopify:section:load', (event) => initTypewriters(event.target));
  document.addEventListener('shopify:section:unload', (event) => stopTypewriters(event.target));
})();
